import React from 'react';
import './login.css';

export const WaveLogo = ({ size = 22 }: { size?: number }) => {
  return (
    <span
      style={{
        position: 'relative',
        display: 'inline-block',
        minWidth: size * 6,
        textAlign: 'center',
      }}
    >
      <span style={{ position: 'relative', display: 'inline-block' }}>
        <h2
          style={{
            fontFamily: "'Poppins', 'Kanit', sans-serif",
            fontSize: size,
            color: 'transparent',
            WebkitTextStroke: '1px #00B061',
            margin: 0,
            fontWeight: 700,
            letterSpacing: '.02em',
          }}
        >
          AutoMagically
        </h2>
        <h2
          style={{
            fontFamily: "'Poppins', 'Kanit', sans-serif",
            fontSize: size,
            color: 'rgba(0,176,97,.85)',
            position: 'absolute',
            inset: 0,
            margin: 0,
            fontWeight: 700,
            letterSpacing: '.02em',
            animation: 'am-wave 5s ease-in-out infinite',
          }}
        >
          AutoMagically
        </h2>
      </span>
    </span>
  );
};

export const AmInput = ({
  label,
  type = 'text',
  value,
  onChange,
  style,
}: {
  label: string;
  type?: string;
  value: string;
  onChange: (v: string) => void;
  style?: React.CSSProperties;
}) => (
  <label style={{ display: 'block', position: 'relative', ...style }}>
    <div
      style={{
        fontSize: 11,
        color: '#808080',
        textTransform: 'uppercase',
        letterSpacing: '.18em',
        marginBottom: 4,
        fontWeight: 500,
      }}
    >
      {label}
    </div>
    <input
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      spellCheck={false}
      style={{
        width: '100%',
        background: 'transparent',
        color: '#fff',
        border: 'none',
        borderBottom: '1px solid #4d4d4d',
        padding: '6px 0 8px 0',
        fontSize: 15,
        fontFamily: 'Kanit, sans-serif',
        outline: 'none',
        boxSizing: 'border-box',
      }}
    />
  </label>
);
